import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { ScanQrcodeStoreContext } from '../contexts/StoreContext'
import { ScanQrcodeStore } from '../store/interface'

export const useScanQrcodeStore: UseStore<ScanQrcodeStore> = selector => {
  return useContextStore(ScanQrcodeStoreContext, selector)
}

export const useScanQrcodeStoreApi = () => {
  return useContextStoreApi(ScanQrcodeStoreContext)
}
